"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function SummaryBox({ children, heading }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: "usa-summary-box", role: "complementary", children: (0, jsx_runtime_1.jsxs)("div", { className: "usa-summary-box__body", children: [(0, jsx_runtime_1.jsx)("h3", { className: "usa-summary-box__heading", children: heading }), (0, jsx_runtime_1.jsx)("div", { className: "usa-summary-box__text", children: (0, jsx_runtime_1.jsx)("ul", { className: "usa-list", children: children }) })] }) }));
}
exports.default = SummaryBox;
